import type {
  ServiceTypeListItemAdminApiOutContract,
  VisitTypeListItemAdminApiOutContract,
} from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

export type NormalizedVisitTypes = {
  entities: Record<string, VisitTypeListItemAdminApiOutContract>
  ids: string[]
}

export type NormalizedServiceType = Omit<ServiceTypeListItemAdminApiOutContract, 'VisitTypes'> & {
  VisitTypes: NormalizedVisitTypes
}

export type NormalizedServiceTypes = {
  entities: Record<string, NormalizedServiceType>
  ids: string[]
}

/**
 * Normalizes the service-types list into the keyed { entities, ids } shape that the legacy
 * `management.normalizedServiceTypes` Redux slice exposed. Extracted verbatim from
 * ManagementReducer so React Query consumers can derive the same structure.
 */
export const normalizeServiceTypes = (serviceTypes: ServiceTypeListItemAdminApiOutContract[]): NormalizedServiceTypes =>
  serviceTypes.reduce<NormalizedServiceTypes>(
    (serviceTypesNorm, serviceTypesValue) => {
      const visitTypes = serviceTypesValue.VisitTypes ?? []

      const VisitTypesNormalized = visitTypes.reduce<NormalizedVisitTypes>(
        (visitTypesNorm, visitTypesValue) => {
          const visitTypeId = visitTypesValue.VisitTypeId ?? ''
          visitTypesNorm.entities[visitTypeId] = visitTypesValue
          visitTypesNorm.ids.push(visitTypeId)

          return visitTypesNorm
        },
        { entities: {}, ids: [] },
      )

      const serviceTypeId = serviceTypesValue.ServiceTypeId ?? ''
      serviceTypesNorm.entities[serviceTypeId] = {
        ...serviceTypesValue,
        VisitTypes: VisitTypesNormalized,
      }
      serviceTypesNorm.ids.push(serviceTypeId)

      return serviceTypesNorm
    },
    { entities: {}, ids: [] },
  )
